import React from "react";
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import SubPage from 'components/pages/user/sub-pages';


const UserRoute = ({ user, history }) => {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }/dealer` } >
                <SubPage.Dealer
                    user={ user }
                    history={ history } />
            </Route>

            <Route path={ `${ path }/posts` } >
                <SubPage.Posts
                    user={ user }
                    history={ history } />
            </Route>

            <Route path={ `${ path }/posts/page/:pageNum` } exact>
                <SubPage.Posts
                    user={ user }
                    history={ history } />
            </Route>

            <Route path={ `${ path }/questions` } >
                <SubPage.Questions
                    user={ user }
                    history={ history } />
            </Route>

            <Route path={ `${ path }/questions/page/:pageNum` } exact>
                <SubPage.Questions
                    user={ user }
                    history={ history } />
            </Route>

            <Route path={ `${ path }` }>
                <SubPage.OverView
                    user={ user }
                    history={ history } />
            </Route>
        </Switch>
    );
};

export default UserRoute;